import { render, staticRenderFns } from "./auth-selector.vue?vue&type=template&id=04aeb0f5"
import script from "./auth-selector.vue?vue&type=script&lang=js"
export * from "./auth-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports